import React from 'react';
import { connect, useSelector } from 'react-redux';

import { BALANCE_ISSUE, MIN_AMOUNT_ISSUE } from 'apps/auth/constants/Constants';
import { AMOUNT_FROM } from 'apps/auth/constants/fieldsName';
import { SEND_FORM_NAME } from 'apps/auth/constants/formName';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useForm } from 'apps/auth/hooks/selectors';

import DcAchAccount from './DcAchAccount';

const DcAchAccounts = (props) => {
    const { fields } = useForm(props.formName);
    const fromRestriction = props.paymentMethod?.commission?.restrictionFrom;
    const amountFrom = fields[AMOUNT_FROM].value;
    const { accountBalanceNotEnough, accountAccessExpired } = useSelector(({ messages: { pageMessages } }) => pageMessages);

    const getIssueType = (value, min, _max, balance) => {
        let issueType;
        const fValue = parseFloat(value);
        const fBalance = parseFloat(balance);
        const fMin = parseFloat(min);

        if (fValue > fBalance) {
            issueType = BALANCE_ISSUE;
        } else if (fValue < fMin) {
            issueType = MIN_AMOUNT_ISSUE;
        }

        return issueType;
    };

    const getPopupTitle = (amountIssue, accountBalanceNotEnoughForPopup, accountAccessExpiredForPopup, args) => {
        if (amountIssue === BALANCE_ISSUE) {
            return resolveArguments(accountBalanceNotEnoughForPopup);
        } else {
            return resolveArguments(accountAccessExpiredForPopup, args);
        }
    };

    return (
        <>
            {Array.isArray(props.achAccounts) &&
                props.achAccounts.length > 0 &&
                props.achAccounts.map((account) => {
                    const arg = [account.alias, account.description];
                    const issueType = getIssueType(amountFrom, fromRestriction?.minAmount, fromRestriction?.maxAmount, account.balance);
                    const popupText = getPopupTitle(issueType, accountBalanceNotEnough, accountAccessExpired, arg);
                    return (
                        <DcAchAccount
                            fields={props.fields}
                            balance={account.balance}
                            isNotEnoughFunds={issueType === BALANCE_ISSUE}
                            isBelowMinAmount={false}
                            isAccessRevocation={false}
                            popupText={popupText}
                            paymentMethod={props.paymentMethod}
                            formName={props.formName}
                            account={account}
                            clickHandler={props.clickHandler}
                            returnToCalculator={props.returnToCalculator}
                            messages={props.messages}
                            key={account.code}
                            badge={props.badge}
                            actionBanner={props.actionBanner}
                        />
                    );
                })}
        </>
    );
};

const mapStateToProps = ({ messages, form }) => {
    return {
        fields: form[SEND_FORM_NAME].fields,
        messages: messages,
    };
};
export default connect(mapStateToProps)(DcAchAccounts);
